<template>
  <v-container
    class="fill-height"
  >
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        cols="12"
        md="8"
      >
        <v-card class="elevation-5 mb-5">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(submit)">
              <v-toolbar
                class="lighten-1"
                color="indigo"
                dark
                flat
              >
                <v-toolbar-title>Регистрация<span class="hidden-md-and-down"> для подачи заявлений ONLINE</span>
                </v-toolbar-title>
                <v-spacer/>
              </v-toolbar>
              <v-card-text>
                <v-alert
                  class="indigo--text hidden-sm-and-down"
                  :icon="mdiExclamation"
                  colored-border
                  prominent
                  outlined
                >
                  <p class="mb-1">Регистрация необходима для создания вашего личного кабинета.</p>
                  <p class="mb-0">Если у вас уже имеется учетная запись,
                    <router-link class="indigo--text" :to="{name: 'login'}">войдите</router-link>
                    в свой личный кабинет.
                  </p>
                </v-alert>
                <ValidationProvider mode="lazy" name="detail" v-slot="{ errors }">
                  <v-alert
                    dense
                    outlined
                    type="error"
                    v-if="errors[0]"
                  >
                    <div class="caption" v-html="errors[0]"></div>
                  </v-alert>
                </ValidationProvider>

                <v-row no-gutters>
                  <v-text-field
                    style="display: none"
                    autocomplete="email new_password1 new_password2"
                  ></v-text-field>
                  <!-- Фамилия -->
                  <v-col cols="12" md="4">
                    <ValidationProvider mode="eager" name="last_name" rules="required|alpha" v-slot="{ errors }">
                      <v-text-field
                        :error-messages="errors"
                        :messages="['Ваша фамилия']"
                        class="mr-md-3"
                        label="Фамилия"
                        name="last_name"
                        type="text"
                        v-model="last_name"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <!-- Имя -->
                  <v-col cols="12" md="4">
                    <ValidationProvider mode="eager" name="first_name" rules="required|alpha" v-slot="{ errors }">
                      <v-text-field
                        :error-messages="errors"
                        :messages="['Ваше имя']"
                        class="mr-md-3"
                        label="Имя"
                        name="first_name"
                        type="text"
                        v-model="first_name"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <!-- Дата рождения -->
                  <v-col cols="12" md="4">
                    <v-menu
                      ref="birthdayMenu"
                      v-model="birthdayMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider
                          mode="lazy"
                          name="birthday"
                          :rules="{required:birthday, regex:/(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/}"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            class="mr-md-3"
                            v-model="birthday"
                            label="Дата рождения"
                            readonly
                            v-on="on"
                            v-bind="attrs"
                            @blur="birthdayISO = parseDate(birthday)"
                            :error-messages="errors"
                            name="birthday"
                            :messages="['Ваша дата рождения']"
                            hint="Выберите год, месяц и число"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        class="indigo--text"
                        color="indigo"
                        ref="picker"
                        :active-picker.sync="birthdayActivePicker"
                        v-model="birthdayISO"
                        :max="getMaxDate"
                        min="1950-01-01"
                        @input="birthdayMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <ValidationProvider mode="eager" name="email" rules="required|email|max:254" v-slot="{ errors }">
                  <v-text-field
                    class="mr-md-3"
                    :error-messages="errors"
                    :messages="['Действительный адрес вашей электронной почты']"
                    label="Электронная почта"
                    name="email"
                    type="text"
                    v-model="email"
                    autocomplete="new-email"
                  ></v-text-field>
                </ValidationProvider>
                <v-row no-gutters>
                  <v-col cols="12" md="6">
                    <ValidationProvider
                      mode="eager"
                      name="new_password1"
                      rules="required|min:8|max:128"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        :error-messages="errors"
                        :messages="['Минимальная длина пароля 8 символов']"
                        class="mr-md-3"
                        label="Пароль"
                        name="new_password1"
                        type="password"
                        v-model="new_password1"
                        autocomplete="new-password"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <ValidationProvider
                      mode="eager"
                      name="new_password2"
                      rules="required|confirmed:new_password1|min:8|max:128"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        :error-messages="errors"
                        :messages="['Ваш пароль еще раз']"
                        class="mr-md-3"
                        label="Пароль повторно"
                        name="new_password2"
                        type="password"
                        v-model="new_password2"
                        autocomplete="new-password"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>


              </v-card-text>
              <v-card-subtitle>
                Нажимая на кнопку <span class="font-weight-bold">«Продолжить»</span>
                вы подтверждаете, что ознакомились с
                <a
                  class="font-weight-regular indigo--text"
                  target="_blank"
                  v-bind:href="'/files/Пользовательское_соглашение.pdf'">
                  пользовательским соглашением</a>
                и принимаете его условия на обработку своих персональных данных.
                <br/><br/>
                <!--<a
                  class="font-weight-regular indigo--text"
                  target="_blank"
                  v-bind:href="'/files/Памятка_для_поступающих_дистанционно.pdf'">
                  Инструкция для поступающих дистанционно
                </a>-->
              </v-card-subtitle>
              <v-card-actions>
                <help-registration></help-registration>
                <v-spacer></v-spacer>
                <v-btn
                  :loading="isLoading"
                  right
                  dark
                  class="lighten-1"
                  color="ma-2 indigo"
                  type="submit"
                >
                  Продолжить
                </v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {extend, localize, ValidationObserver, ValidationProvider} from "vee-validate";
  import {mapGetters} from "vuex";
  import {alpha, confirmed, email, max, min, regex, required} from "vee-validate/dist/rules";
  import {mdiExclamation} from '@mdi/js'
  import HelpRegistration from "../../components/auth/dialogs/HelpRegistration";

  extend('regex', {
    ...regex
  });

  export default {
    name: "Registration",
    components: {
      HelpRegistration,
      ValidationProvider,
      ValidationObserver,
    },
    data() {
      return {
        first_name: '',
        last_name: '',
        email: '',
        birthday: '',
        birthdayISO: null,
        birthdayMenu: false,
        birthdayActivePicker: null,
        new_password1: '',
        new_password2: '',

        mdiExclamation,
      }
    },
    computed: {
      ...mapGetters("context", [
        'isLoading',
        'messages',
      ]),
      ...mapGetters("auth", [
        'is_authenticated',
      ]),
      getMaxDate() {
        let date = new Date();
        date.setFullYear(date.getFullYear() - 14);
        return date.toISOString().substr(0, 10);
      }
    },
    watch: {
      birthdayMenu (val) {
        val && setTimeout(() => (this.birthdayActivePicker = 'YEAR'))
      },
      birthdayISO() {
        this.birthday = this.formatDate(this.birthdayISO)
      },
    },
    methods: {
      async submit() {
        await this.$refs.observer.validate().then(success => {
          if (!success) {
            return;
          }

          const {
            first_name,
            last_name,
            birthdayISO,
            email,
            new_password1,
            new_password2
          } = this

          this.$store.commit("context/CLEAR_MESSAGES");
          this.$store.dispatch("auth/registration", {
            first_name,
            last_name,
            birthday: birthdayISO,
            email,
            new_password1,
            new_password2
          })
            .then(() => {
              if (this.messages) {
                this.$refs.observer.setErrors(this.messages);
              } else {
                this.$router.push({name: "profile_personal"})
              }
            })
            .catch(() => {
              this.$refs.observer.setErrors({
                'detail': 'Неизвестная ошибка. Обратитесь в поддержку: <a href="mailto:abit@kuzstu.ru">abit@kuzstu.ru</a>',
              });
            });

          this.new_password1 = this.new_password2 = ''
          this.$nextTick(() => {
            this.$refs.observer.reset();
          });
        });
      },
      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      },
      parseDate(date) {
        if (!date) return null

        const [day, month, year] = date.split('.')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
    }
  }

  localize({
    ru: {
      names: {
        first_name: ' ',
        last_name: ' ',
        email: ' ',
        birthday: ' ',
        new_password1: ' ',
        new_password2: ' ',
      }
    }
  });

  extend('confirmed', {
    ...confirmed,
    message: 'Поле не совпадает с полем `Пароль`'
  });
  extend('alpha', {
    ...alpha
  });
  extend('required', {
    ...required
  });
  extend('regex', {
    ...regex
  });
  extend('email', {
    ...email
  });
  extend('min', {
    ...min
  });
  extend('max', {
    ...max
  });
</script>
